export const boldText = () => ({ text: { fontWeight: 700 } });
export const leftWideCell = () => ({ item: { paddingLeft: '32px' } });
export const uppercase = () => ({ text: { textTransform: 'uppercase' } });
export const textWrap = () => ({ text: { whiteSpace: 'break-spaces' } });
